import { render, staticRenderFns } from "./ChatControls.vue?vue&type=template&id=73845520&"
import script from "./ChatControls.vue?vue&type=script&lang=js&"
export * from "./ChatControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports